import { render } from "./ImageCarouselComponent.vue?vue&type=template&id=e090d9aa&scoped=true&ts=true"
import script from "./ImageCarouselComponent.vue?vue&type=script&lang=ts"
export * from "./ImageCarouselComponent.vue?vue&type=script&lang=ts"

import "./ImageCarouselComponent.vue?vue&type=style&index=0&id=e090d9aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e090d9aa"]])

export default __exports__